import { createSlice } from '@reduxjs/toolkit';
import { conversationsApi } from '~/api/conversations-api';

// Define the Conversation type
export interface Conversation {
  id?: string;
  messages?: string[];
}

// Define the state interface for conversations
interface ConversationsState {
  conversations: Conversation[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ConversationsState = {
  conversations: [],
  status: 'idle',
  error: null,
};

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle getConversations endpoint actions from RTK Query
    builder
      .addMatcher(conversationsApi.endpoints.getConversations.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(conversationsApi.endpoints.getConversations.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.conversations = action.payload;
      })
      .addMatcher(conversationsApi.endpoints.getConversations.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch conversations';
      });
  },
});

export default conversationsSlice.reducer;
